module.exports = __webpack_public_path__ + "static/logo-ff6dfb28942dc5045fcf7dc10922d62d.png";